namespace Matrix.Rebalancer {
    export interface TradeMacroAssignmentRow {
        AccountCode?: string;
        CashflowType?: string;
        Macro1?: string;
        Macro2?: string;
        Macro3?: string;
        Macro4?: string;
        Macro5?: string;
        Macro6?: string;
        Macro7?: string;
        Macro8?: string;
        Macro9?: string;
        Macro10?: string;
        Macro11?: string;
        Macro12?: string;
        Macro13?: string;
        Macro14?: string;
        Macro15?: string;
        Macro16?: string;
        Macro17?: string;
        Macro18?: string;
        Macro19?: string;
        Macro20?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AccountName?: string;
        AccountRowId?: number;
        Macro1Description?: string;
        Macro2Description?: string;
        Macro3Description?: string;
        Macro4Description?: string;
        Macro5Description?: string;
        Macro6Description?: string;
        Macro7Description?: string;
        Macro8Description?: string;
        Macro9Description?: string;
        Macro10Description?: string;
        Macro11Description?: string;
        Macro12Description?: string;
        Macro13Description?: string;
        Macro14Description?: string;
        Macro15Description?: string;
        Macro16Description?: string;
        Macro17Description?: string;
        Macro18Description?: string;
        Macro19Description?: string;
        Macro20Description?: string;
    }

    export namespace TradeMacroAssignmentRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'Rebalancer.TradeMacroAssignment';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            AccountCode = "AccountCode",
            CashflowType = "CashflowType",
            Macro1 = "Macro1",
            Macro2 = "Macro2",
            Macro3 = "Macro3",
            Macro4 = "Macro4",
            Macro5 = "Macro5",
            Macro6 = "Macro6",
            Macro7 = "Macro7",
            Macro8 = "Macro8",
            Macro9 = "Macro9",
            Macro10 = "Macro10",
            Macro11 = "Macro11",
            Macro12 = "Macro12",
            Macro13 = "Macro13",
            Macro14 = "Macro14",
            Macro15 = "Macro15",
            Macro16 = "Macro16",
            Macro17 = "Macro17",
            Macro18 = "Macro18",
            Macro19 = "Macro19",
            Macro20 = "Macro20",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AccountName = "AccountName",
            AccountRowId = "AccountRowId",
            Macro1Description = "Macro1Description",
            Macro2Description = "Macro2Description",
            Macro3Description = "Macro3Description",
            Macro4Description = "Macro4Description",
            Macro5Description = "Macro5Description",
            Macro6Description = "Macro6Description",
            Macro7Description = "Macro7Description",
            Macro8Description = "Macro8Description",
            Macro9Description = "Macro9Description",
            Macro10Description = "Macro10Description",
            Macro11Description = "Macro11Description",
            Macro12Description = "Macro12Description",
            Macro13Description = "Macro13Description",
            Macro14Description = "Macro14Description",
            Macro15Description = "Macro15Description",
            Macro16Description = "Macro16Description",
            Macro17Description = "Macro17Description",
            Macro18Description = "Macro18Description",
            Macro19Description = "Macro19Description",
            Macro20Description = "Macro20Description"
        }
    }
}
